/*
 * Shared app footer — the dark mot-r footer shown across every route.
 *
 * Moved from web/src/tools/plan-builder/components/Footer.tsx.
 * CSS class names are renamed .pb-footer* → .app-footer* (lives in AppShell.css).
 */

export function AppFooter() {
  return (
    <footer className="app-footer no-print">
      <div className="app-footer-logo">mot-r Legal Operations Improvement Plan</div>
      <div className="app-footer-refs">
        Built on IHI (Perlo et al., 2017) · Heath <em>Reset</em> (2025) · Klein
        Pre-Mortem (HBR, 2007) · Pfeffer &amp; Sutton EBM
      </div>
      <div className="app-footer-copy">© 2026 mot-r</div>
    </footer>
  );
}
